import { useState } from 'react';
import CreateCardTypeCategoryModal from './CreateCardTypeCategoryModal';

/**
 * Wrapper that manages CreateCardTypeCategoryModal open state.
 * Use render prop to get openModal callback for the trigger.
 */
export default function CreateCategoryModalContainer({
    user,
    sport,
    year,
    manufacturer,
    series,
    cardType,
    onCategoryCreated,
    children,
}) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            {children(() => setIsOpen(true))}
            <CreateCardTypeCategoryModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                user={user}
                sport={sport}
                year={year}
                manufacturer={manufacturer}
                series={series}
                cardType={cardType}
                onCategoryCreated={onCategoryCreated}
            />
        </>
    );
}
